import React, { useState } from 'react';
import { Button } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signInWithApple } from '../services/appleAuth';
import { setUser } from '../store/slices/User';

interface AppleSignInButtonProps {
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  disabled?: boolean;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

const AppleSignInButton: React.FC<AppleSignInButtonProps> = ({
  fullWidth = true,
  variant = 'outlined',
  disabled = false,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAppleSignIn = async () => {
    setLoading(true);
    try {
      const response = await signInWithApple();
      const { user, idToken } = response;

      const userData = {
        _id: user.uid,
        email: user.email,
        username: user.displayName || user.email?.split('@')[0],
        firstName: user.displayName?.split(' ')[0] || '',
        lastName: user.displayName?.split(' ')[1] || '',
        photoURL: user.photoURL,
        emailVerified: user.emailVerified,
        isAppleUser: true,
      };

      dispatch(setUser(userData));

      if (onSuccess) {
        onSuccess();
      } else {
        navigate('/');
      }
    } catch (error: any) {
      console.error('Apple sign-in failed:', error);
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      onClick={handleAppleSignIn}
      disabled={disabled || loading}
      sx={{
        textTransform: 'none',
        borderColor: '#F57C00',
        backgroundColor: '#FFF3E0',
        color: '#000',
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.08)',
          borderColor: '#F57C00',
        },
        height: '40px',
        fontSize: '14px',
        fontWeight: 500,
        mb: 1,
      }}
      // startIcon={<AppleIcon />}
    >
      {loading ? 'Signing in...' : 'Continue with Apple'}
    </Button>
  );
};

export default AppleSignInButton; 